export default {
  searchQuery(state, value) {
    state.searchQuery = value;
  },
  benefitAndDeductionTypes(state, value) {
    state.benefitAndDeductionTypes = value;
  },
  benefitAndDeductionTypesTotal(state, value) {
    state.benefitAndDeductionTypesTotal = value;
  },
  benefitAndDeductionTypesCurrentPage(state, value) {
    state.benefitAndDeductionTypesCurrentPage = value;
  },
  benefitAndDeductionTypesPerPage(state, value) {
    state.benefitAndDeductionTypesPerPage = value;
  },
  tableLoading(state, value) {
    state.tableLoading = value;
  },
  benefitAndDeduction(state, value) {
    state.benefitAndDeduction = value;
  },
  benefitAndDeductionTotal(state, value) {
    state.benefitAndDeductionTotal = value;
  },
  benefitAndDeductionCurrentPage(state, value) {
    state.benefitAndDeductionCurrentPage = value;
  },
  benefitAndDeductionPerPage(state, value) {
    state.benefitAndDeductionPerPage = value;
  },

  benefitAndDeductionApprovalSetting(state, value) {
    state.benefitAndDeductionApprovalSetting = value;
  },

  approvalSettingPerPage(state, value) {
    state.approvalSettingPerPage = value;
  },
  approvalSettingCurrentPage(state, value) {
    state.approvalSettingCurrentPage = value;
  },
  approvalSettingTotal(state, value) {
    state.approvalSettingTotal = value;
  },
  approvals(state, value) {
    state.approvals = value;
  },
  approvalsTotal(state, value) {
    state.approvalsTotal = value;
  },
  approvalCurrentPage(state, value) {
    state.approvalCurrentPage = value;
  },
  approvalPerPage(state, value) {
    state.approvalPerPage = value;
  },
};
